import { createI18n } from 'vue-i18n'

import de from './locales/de'
import en from './locales/en'
import hr from './locales/hr'
import hu from './locales/hu'
import it from './locales/it'
import sl from './locales/sl'

/**
 * Six languages, the same six the guest portal ships.
 *
 * The other staff-facing portals ship two, and that is right for them: `pms-web` is a
 * reception desk and `pms-housekeeping` is a supervisor's floor, both worked by people
 * the house hired to talk to guests in Slovenian. This one is read by EVERYBODY on the
 * payroll — the kitchen, the laundry, maintenance, the seasonal help — and in a
 * Slovenian hotel chain that is a Croatian, a Hungarian, a Bosnian and a Serbian
 * workforce as often as not.
 *
 * What it is being read FOR is the other half of the argument: a rota somebody has to
 * arrange their week around, a refusal to a request for leave, and a legal record of
 * their own hours. Those are the last things in this product anybody should be reading
 * in a second language, and „Moja ura“ in a language somebody half follows is a stamp
 * pressed at the wrong moment.
 *
 * Slovenian is the default and English the fallback, exactly as everywhere else here.
 */
export type AvailableLocales = 'sl' | 'en' | 'hr' | 'hu' | 'de' | 'it'

/**
 * The list as data, so that `libs/session.ts` can check an account's language against it
 * rather than against a type that does not exist at run time. A card naming a language
 * this portal does not ship must be ignored, not applied — `vue-i18n` would silently
 * fall back to English, and English is nobody's default in this house.
 */
export const AVAILABLE_LOCALES: string[] = ['sl', 'en', 'hr', 'hu', 'de', 'it']

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           localStorage.getItem('locale') || 'sl',
    fallbackLocale:   'en',
    messages:         { sl, en, hr, hu, de, it },
    availableLocales: AVAILABLE_LOCALES,
})

export default i18n
